import HttpRequestService from "./HttpRequestService";

const PaymentService = {};

const cntrlName = "student/SaveStudentFees";

//API for get all data
PaymentService.SavePaymentDetails = function (body) {
  return HttpRequestService.post(cntrlName, body);
};

export default PaymentService;
